import { bootstrap as bootstrapIntercom } from 'utils/intercom'
import { useEffect } from 'react'

export default function Intercom() {
  useEffect(bootstrapIntercom, [])
  return null
}
